import Blob from "../components/Blob";
import { useStore } from "../store";

export default function BlobGroup(props: JSX.IntrinsicElements["group"]) {
  const radius = useStore((state) => state.blobRadius);

  return (
    <>
      <group rotation={[0, 0, 0]} {...props}>
        <Blob
          prefix="pine"
          size={2.34}
          offset={{ x: 0.064, y: 0.058 }}
          radius={radius}
          opacity={0.05}
          xy={[0, 1]}
        />
        <Blob
          prefix="beige"
          size={1.9}
          offset={{ x: 0.048, y: -0.082 }}
          radius={radius}
          opacity={0.05}
          xy={[0, -1]}
        />
        <Blob
          prefix="sienna"
          size={2.75}
          offset={{ x: 0.319, y: 1.068 }}
          radius={radius}
          opacity={0.05}
          xy={[1, 0]}
        />
      </group>
      <group>
        <Blob
          prefix="teal"
          size={3.75}
          offset={{ x: 0.3, y: 1.2 }}
          radius={radius}
          opacity={0.15}
          rotation={[0, 0, Math.PI * 0.6]}
          xy={[0, 0]}
        />
        <Blob
          prefix="pine"
          size={2.9}
          offset={{ x: -2.997, y: 0.475 }}
          radius={0}
          opacity={0.1}
          rotation={[0, 0, Math.PI * 0.45]}
          xy={[0, 0]}
        />
      </group>
    </>
  );
}
